import { render } from "./FormatBold.vue?vue&type=template&id=8f21dd72"
import script from "./FormatBold.vue?vue&type=script&lang=js"
export * from "./FormatBold.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__